import Editor from "./Editor/Editor";
import ChatPreview from "./Preview/Preview";
import { Flex, ConfigProvider } from "antd";
import {
  createBrowserRouter,
  RouterProvider,
  useParams,
} from "react-router-dom";
import ChatConfigContext from "./Editor/ChatEditor/ChatConfigContext";
import KnowledgeConfigContext from "./Editor/KnowledgeEditor/KnowledgeConfigContext";
import { useState } from "react";

const AppRoot = () => {
  const router = createBrowserRouter([
    {
      path: "/:brand",
      element: <App />,
    },
  ]);

  return <RouterProvider router={router} />;
};

const App = () => {
  const [chatConfig, setChatConfig] = useState(ChatConfigContext);
  const [knowledgeConfig, setKnowledgeConfig] = useState(
    KnowledgeConfigContext
  );
  const [reload, setReload] = useState(false);
  const brand = useParams().brand;

  return (
    <KnowledgeConfigContext.Provider
      value={{ knowledgeConfig, setKnowledgeConfig }}
    >
      <ChatConfigContext.Provider value={{ chatConfig, setChatConfig }}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#9767ff",
            },
          }}
        >
          <div className="App h-screen">
            <Flex vertical={false} className="h-full">
              <div className="w-2/3 h-full">
                <Editor brand={brand} />
              </div>
              <div className="w-1/3 h-full">
                <button
                  onClick={() => {
                    setReload(true);
                    setTimeout(() => setReload(false), 200);
                  }}
                >
                  Reset
                </button>
                {!reload && (
                  <ChatPreview
                    configs={chatConfig}
                    knowledge={knowledgeConfig}
                  />
                )}
              </div>
            </Flex>
          </div>
        </ConfigProvider>
      </ChatConfigContext.Provider>
    </KnowledgeConfigContext.Provider>
  );
};

export default AppRoot;
